import { render, staticRenderFns } from "./SubmitEvaluation.vue?vue&type=template&id=71792696"
import script from "./SubmitEvaluation.vue?vue&type=script&lang=js"
export * from "./SubmitEvaluation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports